import {
  anUpdateSuppressList,
  aSuppressList,
  mockUpdateSuppressedListOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateSuppressedListHandler = ({
  id,
  name,
  description,
  timeToLiveInSeconds,
}) => ({
  __typename: 'Mutation',
  updateSuppressList: {
    ...anUpdateSuppressList(),
    data: aSuppressList({
      defaultTtl: timeToLiveInSeconds,
      description,
      id,
      name,
      targetColumn: '1',
    }),
  },
});

export const handlers = [
  mockUpdateSuppressedListOperationMutation(
    async ({ query: _query, variables }) => {
      await delay(1500);
      const {
        id,
        fields: { description, defaultTtl },
      } = variables;
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateSuppressList: anUpdateSuppressList({
            data: aSuppressList({
              id,
              description,
              defaultTtl,
            }),
          }),
        },
      });
    }
  ),
];
